<template>
  <div class="container">
    <div id="variacao" class="row">
      <div class="col-sm-8">
        <ul>
          <li><strong>Referência:</strong> {{ referencia }}</li>
          <li><strong>Produto:</strong> {{ nomeproduto }}</li>
          <li><strong>Descrição:</strong> {{ descSku }}</li>
          <div class="row">
            <div class="col-sm-7">
              <li><strong>Preço Unitário:</strong> R$ {{ precoindividual }}</li>
            </div>
            <div class="col">
              <li><strong>Quantidade:</strong> {{ quantidade }}</li>
            </div>
          </div>
          <li><strong>Total:</strong> R$ {{ precoTotalmente }}</li>
        </ul>
      </div>
      <div class="col">
        <img :src="url" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "referencia",
    "nomeproduto",
    "descSku",
    "preco",
    "quantidade",
    "precoTotal",
    "url",
  ],
  data() {
    return {};
  },
  computed: {
    precoTotalmente() {
      return (this.preco*this.quantidade).toLocaleString("pt-br", {
        minimumFractionDigits: 2,
      });
    },
    precoindividual() {
      if (this.preco !== null && this.preco !== undefined) {
        return this.preco.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
        });
      } else {
        return "0,00";
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0;
  margin: 0;
}
#variacao {
  border-top: 1px solid rgba(0, 0, 0, 0.405);
  margin: 20px auto;
}

ul {
  list-style: none;
  margin: 1rem 0rem;
  padding: 0;
}

li {
  font-size: 15px;
  text-align: left;
}

p {
  margin: 2rem auto;
}

img {
  width: 7rem;
  margin: 1rem 0rem;
  border-radius: 20px;
}
</style>
